'use client'

import { ReactNode } from 'react'

import { useChangePageView } from 'src/hooks'

export default function GaRegistry({ children }: { children: ReactNode }) {
  useChangePageView()

  return <div>{children}</div>
}
